import React from 'react'
// libs
import { useSelector } from 'react-redux'
import { formValueSelector } from 'redux-form'
// constants
import { Forms } from 'constants/forms'
import { NO_VALUE_FIELD_TYPES } from 'constants/objects'
// types
import { WrappedFieldArrayProps } from 'redux-form/lib/FieldArray'
// views
import { FieldsWrapper, SourceWrapper } from './views'
import { AddButton, CloseIcon } from 'components/Modals/LookupFilterModal/components/Form/components/Rules/views'
// store
import { riskTemplatesSelector } from 'store/reducers/riskTemplates'
// components
import { ReduxEntitySelect, ReduxSelect } from 'components/FormElements'
// graphql
import { RISK_TEMPLATE_SELECT_QUERY } from 'graphql/risk/queries'
// utils
import { required } from 'utils/validators'
import { riskTemplatesProps } from 'components/FormElements/ReduxForm/ReduxEntitySelect/utils'

const selector = formValueSelector(Forms.RISK_VIEW_FORM)

interface Props {
  field: string
  remove: () => void
}

const Source: React.FC<Props> = ({ field, remove }) => {
  const riskTemplates = useSelector(riskTemplatesSelector)

  const template = useSelector((state) => selector(state, `${field}.templateId`))

  const properties = riskTemplates
    .find((t) => t.id === template?.value)
    ?.fields.filter((f) => !NO_VALUE_FIELD_TYPES.includes(f.fieldType))
    .map((f) => ({
      label: f.label,
      value: f.id
    }))

  return (
    <SourceWrapper data-testid='risk-view-custom-column-source'>
      <FieldsWrapper>
        <ReduxEntitySelect
          label='Parent Form'
          menuPlacement='top'
          validate={required}
          menuPortalTarget={null}
          name={`${field}.templateId`}
          query={RISK_TEMPLATE_SELECT_QUERY}
          {...riskTemplatesProps}
        />
        <ReduxSelect
          label='Property'
          validate={required}
          options={properties}
          menuPlacement='top'
          menuPortalTarget={null}
          name={`${field}.fieldId`}
        />
      </FieldsWrapper>
      <CloseIcon data-testid='remove-custom-column-source' onClick={remove} />
    </SourceWrapper>
  )
}

const Sources: React.FC<WrappedFieldArrayProps> = ({ fields }) => {
  const addRule = () => fields.push({})

  const removeRule = (idx: number) => () => fields.remove(idx)

  React.useEffect(() => {
    if (!fields.length) {
      fields.push({})
    }
  }, [fields.length])

  return (
    <>
      {fields.map((field, idx) => (
        <Source key={field} field={field} remove={removeRule(idx)} />
      ))}
      <AddButton data-testid='add-custom-column-source' onClick={addRule}>
        + add parent form property
      </AddButton>
    </>
  )
}

export default Sources
